const hasOwn = (object, key) => Object.prototype.hasOwnProperty.call(object, key);

export const compactCltStatusHashes = (status) => {
  const hashes = status.hashMap || {};
  const arrays = new Set(Object.keys(status.map || {}).filter((key) => Array.isArray(status.map[key]) && hasOwn(hashes, key)));
  const entries = Object.entries(hashes).filter(([key]) => {
    if (hasOwn(status.map || {}, key)) return true;
    if (key.endsWith(':array:length') && arrays.has(key.slice(0, -':array:length'.length))) return false;
    const match = key.match(/^(.*):array:index:(\d+)$/);
    return !match || !arrays.has(match[1]) || !hasOwn(hashes, `${match[1]}:array:length`);
  });
  return entries.length === Object.keys(hashes).length ? status : { ...status, hashMap: Object.fromEntries(entries) };
};

const mergeCltStatus = (previous, incoming = {}) => {
  const base = previous || {};
  const diffMap = incoming.map || {};
  const diffHashMap = incoming.hashMap || {};
  const map = { ...(base.map || {}) };
  const hashMap = { ...(base.hashMap || {}) };
  const arrayDiffKeys = new Set();

  Object.keys(diffMap)
    .filter((key) => key.endsWith('DiffIndices'))
    .map((key) => key.slice(0, -'DiffIndices'.length))
    .filter((key) => hasOwn(diffMap, key) && hasOwn(diffMap, `${key}DiffFull`))
    .forEach((key) => {
      const changed = diffMap[key];
      const indices = diffMap[`${key}DiffIndices`];
      if (!Array.isArray(changed) || !Array.isArray(indices)) {
        throw new Error(`Invalid array diff for ${key}`);
      }

      if (diffMap[`${key}DiffFull`]) {
        map[key] = changed;
      } else {
        const next = Array.isArray(map[key]) ? [...map[key]] : null;
        if (!next || changed.length !== indices.length) {
          throw new Error(`Invalid array diff for ${key}`);
        }
        indices.forEach((index, offset) => {
          if (index < 0 || index >= next.length || index % 1 !== 0) {
            throw new Error(`Invalid array index for ${key}`);
          }
          next[index] = changed[offset];
        });
        map[key] = next;
      }

      arrayDiffKeys.add(key);
      arrayDiffKeys.add(`${key}DiffFull`);
      arrayDiffKeys.add(`${key}DiffIndices`);
    });

  Object.keys(diffMap).forEach((key) => {
    if (arrayDiffKeys.has(key)) return;

    if (diffMap[key] === null && diffHashMap[key] === null) {
      delete map[key];
    } else {
      map[key] = diffMap[key];
    }
  });

  Object.keys(diffHashMap).forEach((key) => {
    if (diffHashMap[key] === null) {
      delete hashMap[key];
    } else {
      hashMap[key] = diffHashMap[key];
    }
  });

  return {
    ...base,
    ...incoming,
    map,
    hashMap
  };
};

export default mergeCltStatus;
